import http from "../utils/http";
import { PlayList } from "../pages/content/Playlist";

interface CreateSubscriptionBodyParam {
  name: string;
  price: number;
  duration: number;
  maxPausePeriodAllowed: number;
  benefits: string[];
  shortDescription: string;
  gymMembership: boolean;
  hasFullContentAccess: boolean;
  canRequestDietPlan: boolean;
  hasAllotedContent: boolean;
  onlineMembership: boolean;
  discount: number;
  thumbnailUrl: string;
}

const Savesubscription = async ({
  name,
  price,
  duration,
  maxPausePeriodAllowed,
  benefits,
  shortDescription,
  gymMembership,
  hasFullContentAccess,
  canRequestDietPlan,
  discount,
  thumbnailUrl,
  onlineMembership,
  hasAllotedContent,
}: CreateSubscriptionBodyParam): Promise<number> => {
  const urlPath = `/admin/subscriptions`;

  const result = await http.post({
    path: urlPath,
    body: {
      name,
      price,
      duration,
      maxPausePeriodAllowed,
      benefits,
      shortDescription,
      gymMembership,
      hasFullContentAccess,
      canRequestDietPlan,
      discount,
      thumbnailUrl,
      onlineMembership,
      hasAllotedContent,
    },
  });

  if (result.status == 201) {
    return 201;
  } else {
    return 400;
  }
};

const UpdateSubScrip = async ({
  id,
  price,
  discount,
  shortDescription,
  name,
  thumbnailUrl,
  benefits,
  duration,
  maxPausePeriodAllowed,
}: {
  id: string;
  price: number;
  discount: number;
  shortDescription: string;
  name: string;
  thumbnailUrl: string;
  benefits: String[];
  duration?: number;
  maxPausePeriodAllowed?: number;
}): Promise<number> => {
  const urlPath = `/admin/subscriptions`;

  const result = await http.put({
    path: urlPath,
    body: {
      id,
      name,
      price,
      discount,
      shortDescription,
      thumbnailUrl,
      benefits,
      duration,
      maxPausePeriodAllowed,
    },
  });
  if (result.status == 200) {
    return 200;
  } else {
    return 400;
  }
};

export interface ISubscription {
  id: string;
  name: string;
  price: number;
  duration: number;
  benefits: string[];
  shortDescription: string;
  thumbnailUrl: string | null;
  hasFullContentAccess: boolean;
  canRequestDietPlan: boolean;
  playLists: PlayList[];
  createdAt: string;
  updatedAt: string;
  discount: number;
  maxPausePeriodAllowed?: number;
  newSubscriptionId: string | null;
  active: boolean;
  gymMembership: boolean;
  hasAllotedContent: boolean;
  onlineMembership: boolean;
}

interface Pageable {
  pageNumber: number;
  pageSize: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface GETListResponse<T> {
  content: T[];
  pageable: Pageable;
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  first: boolean;
  empty: boolean;
}

const GetSubScriptionList = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}): Promise<GETListResponse<ISubscription>> => {
  const urlPath = `/admin/subscriptions?page=${page}&size=${size}`;
  const result = await http.get({ path: urlPath });
  if (result.status === 200) {
    return result.data as GETListResponse<ISubscription>;
  } else {
    throw new Error(`Error fetching subscriptions: ${result.statusText}`);
  }
};

const GetSubscriptionById = async ({
  id,
}: {
  id: string;
}): Promise<ISubscription> => {
  const urlPath = `/admin/subscriptions/${id}`;
  const result = await http.get({ path: urlPath });
  if (result.status === 200) {
    return result.data as ISubscription;
  } else {
    throw new Error(`Error fetching subscription: ${result.statusText}`);
  }
};

const DeactivateSubscription = async ({
  id,
}: {
  id: string;
}): Promise<number> => {
  const urlPath = `/admin/subscriptions/deactivate/${id}`;

  const result = await http.put({ path: urlPath, body: {} });

  if (result.status == 204) {
    return 204;
  } else {
    return 401;
  }
};
const ActivateSubscription = async ({
  id,
}: {
  id: string;
}): Promise<number> => {
  const urlPath = `/admin/subscriptions/activate/${id}`;

  const result = await http.put({ path: urlPath, body: {} });

  if (result.status == 204) {
    return 204;
  } else {
    return 401;
  }
};
const AddPlayListTolist = async ({
  playlistId,
  subscriptionId,
}: {
  playlistId: string;
  subscriptionId: string;
}): Promise<number> => {
  const urlPath = "/admin/subscriptions/add-playlist";

  const result = await http.put({
    path: urlPath,
    body: { playlistId, subscriptionId },
  });
  if (result.status == 200) {
    return 200;
  } else {
    return 401;
  }
};

const RemovePlayListFromList = async ({
  playlistId,
  subscriptionId,
}: {
  playlistId: string;
  subscriptionId: string;
}): Promise<number> => {
  const urlPath = "/admin/subscriptions/remove-playlist";

  const result = await http.put({
    path: urlPath,
    body: { playlistId, subscriptionId },
  });

  if (result.status === 200) {
    return 200;
  } else {
    return 401;
  }
};

export {
  Savesubscription,
  GetSubScriptionList,
  GetSubscriptionById,
  DeactivateSubscription,
  ActivateSubscription,
  AddPlayListTolist,
  RemovePlayListFromList,
  UpdateSubScrip,
};
